import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Button } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';



export default function InstanceCompilerTopHook({ data, entity = null, setDataKeyValue }) {

    useEffect(() => {
        console.warn("-- DATA --", data)
        if (entity === "user") {
            console.log(data)
            if (data.name !== "" && data.surname !== "") {
                var nameComplete = data.name + " " + data.surname;
                if (data.nameComplete !== nameComplete) {
                    setDataKeyValue('nameComplete', nameComplete)
                }

            }
        }
        if (entity === "job_request") {
            if (data.idJobPost !== "") {
                localStorage.setItem("idJobPost", data.idJobPost.id)
            }

            var agency = document.getElementById("job_request_field_idAgency")
            if (data.source && data.source.value === "10_AGENCY") {
                agency.style.display = 'block';
            } else {
                agency.style.display = 'none';
            }
        }

    }, [data]);



    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};